import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Select from "./Select";

class Position extends React.Component {
  state = { positionId: this.props.position };

  handleChangePosition = e => {
    const positionId = e.target.value;
    this.setState({ positionId });

    axios.put("/in_services/position", { position_id: positionId }).then(() => {
      toastr.success("In-Service position updated");
    });
  };

  render() {
    const { positionId } = this.state;
    const { positions } = this.props;

    return (
      <div>
        <h4>
          <b>In-Service Position</b>
        </h4>
        <p className="grey-text">
          Link your in-services to a position so you can automatically sync with
          the schedule
        </p>

        <Select
          options={positions}
          value={positionId}
          onChange={this.handleChangePosition}
          selectTitle="In-service Position"
        />
      </div>
    );
  }
}

Position.propTypes = {
  position: PropTypes.string,
  positions: PropTypes.array
};

Position.defaultProps = {
  position: null,
  positions: []
};

export default Position;
